import React from 'react'

export const Label: React.FC<React.LabelHTMLAttributes<HTMLLabelElement>> = ({ style, children, ...rest }) => (
  <label style={{ fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-secondary)', ...style }} {...rest}>{children}</label>
)
